import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mt-4" }
const _hoisted_2 = {
  class: "block ml-3",
  href: "/Массовое закрытие шаблон.xlsx",
  download: "Массовое закрытие шаблон.xlsx"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Массовое закрытие ДК",
    class: "medium",
    overflow: false,
    loading: _ctx.isLoading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_input, {
        value: _ctx.state.date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.date) = $event)),
        placeholder: "Выберите дату и время",
        type: "datetime-local",
        "is-invalid": _ctx.validation$.date.$error,
        "validation-errors": _ctx.validation$.date.$errors,
        disabled: _ctx.isLoading
      }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_file_reader, {
          class: "w-full",
          accept: ".xlsx, .xls",
          placeholder: "Excel файл с номерами накладными",
          value: _ctx.state.file,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.file) = $event)),
          "is-invalid": _ctx.validation$.file.$error,
          "validation-errors": _ctx.validation$.file.$errors,
          disabled: _ctx.isLoading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_new_button, { class: "NewButton--search whitespace-nowrap" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Скачать шаблон ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}